/* =======================================================================
   NEWLAYOUT.JS - Stacked Mattress Card Layout
   Version: 3.5 - Sale strikethrough pricing added
   
   🎨 COLOURS: All colours are defined in :root of newlayout.css.
      This JS file reads them via getComputedStyle — no hex codes here.
   ======================================================================= */

(function() {
  'use strict';

  window.NL = window.NL || {};

  // =======================================================================
  // CONFIGURATION
  // =======================================================================

  var CONFIG = {
    pricesUrl: window.NL_PRICES_URL || '/assets/mattress-prices.json',
    filesBase: window.NL_FILES_BASE || '',
    shapeUrl: window.NL_SHAPE_URL || '',
    stateKey: 'mattressSelections',
    galleryUrl: 'https://www.caravanmattresses.co.uk/pages/customer-success-stories-custom-mattress-gallery',
    debug: true
  };

  // 🎨 NOTE: This SVG fallback has hardcoded brand colour %2357cbab (orange).
  // Update this hex if changing brand colours for a different store.
  var FALLBACK_IMAGE = "data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='90' viewBox='0 0 120 90'%3E%3Crect fill='%23f8f9fa' stroke='%2357cbab' stroke-width='2' stroke-dasharray='5,3' width='116' height='86' x='2' y='2' rx='8'/%3E%3Ctext fill='%2357cbab' font-family='Arial,sans-serif' font-size='11' font-weight='bold' text-anchor='middle' x='60' y='32'%3EChoose shape%3C/text%3E%3Ctext fill='%2357cbab' font-family='Arial,sans-serif' font-size='11' font-weight='bold' text-anchor='middle' x='60' y='46'%3E%26 size%3C/text%3E%3Ctext fill='%23666' font-family='Arial,sans-serif' font-size='9' text-anchor='middle' x='60' y='62'%3Eto see pricing%3C/text%3E%3Cpath fill='none' stroke='%2357cbab' stroke-width='1.5' d='M50 72 L60 67 L70 72'/%3E%3Cline stroke='%2357cbab' stroke-width='1.5' x1='60' y1='67' x2='60' y2='78'/%3E%3C/svg%3E";

  var MATTRESS_NAMES = {
    essential: "Essential Comfort Mattress",
    comfisan: "Comfisan™ Mattress",
    novolatex: "Novolatex™ Mattress",
    bodyshape: "Bodyshape™ Mattress",
    coolplus: "Coolplus™ Mattress",
    "grand-crescent": "Grand Crescent™ Mattress",
    "imperial-elite2": "Imperial Elite™ 2000 Mattress",
    "coolplus-topper": "Coolplus™ Mattress Topper",
    "bodyshape-topper": "Bodyshape™ Mattress Topper"
  };

  // =======================================================================
  // STATE
  // =======================================================================

  var state = {
    shape: null,
    shapeId: null,
    shapeName: null,
    shapeLabel: null,
    size: null,
    sizeLabel: null,
    shapeImageUrl: null,
    prices: null,
    isSwift: false,
    step1Url: null,
    reviewsData: [],
    benefitsData: null
  };

  function log() {
    if (CONFIG.debug) {
      var args = Array.prototype.slice.call(arguments);
      args.unshift('[NL]');
      console.log.apply(console, args);
    }
  }

  // =======================================================================
  // INITIALISATION
  // =======================================================================

  function init() {
    log('Initialising NewLayout v3.5...');
    
    detectSwiftContext();
    loadStateFromStorage();
    loadStateFromUrl();
    loadBenefitsData();
    loadPrices();
    loadReviewsFromGallery();
    setupEventListeners();
    
    // Normalise size value - fixes 'superking' → 'super-king' mismatch
    if (state.size) {
      state.size = state.size.replace(/^superking$/i, 'super-king');
    }
    
    updateUI();
    NL.initCarouselSwipe();
    NL.initCountdown();
    
    // Hide filter-only sections on initial load (e.g. Cooling Technology)
    hideFilterOnlySections();
    
    log('State loaded:', state);
    log('Initialisation complete');
  }

  function detectSwiftContext() {
    var hostname = window.location.hostname;
    if (hostname.indexOf('swiftgroupmattresses') !== -1) {
      state.isSwift = true;
      log('Swift context detected from hostname');
    }

    if (document.referrer && document.referrer.toLowerCase().indexOf('swift') !== -1) {
      state.isSwift = true;
      log('Swift context detected from referrer');
    }

    if (window.location.href.toLowerCase().indexOf('swift') !== -1) {
      state.isSwift = true;
      log('Swift context detected from URL');
    }

    var urlParams = new URLSearchParams(window.location.search);
    urlParams.forEach(function(value, key) {
      if (value.toLowerCase().indexOf('swift') !== -1 || key.toLowerCase().indexOf('swift') !== -1) {
        state.isSwift = true;
        log('Swift context detected from URL parameter');
      }
    });

    try {
      if (sessionStorage.getItem('swiftContext') === 'true') {
        state.isSwift = true;
        log('Swift context detected from session storage');
      }
    } catch (e) {}

    var urlParams = new URLSearchParams(window.location.search);
    var returnTo = urlParams.get('returnTo');
    state.step1Url = returnTo ? decodeURIComponent(returnTo) : '/';
    
    log('Swift context:', state.isSwift, 'Step 1 URL:', state.step1Url);
  }

  function loadStateFromStorage() {
    try {
      var stored = sessionStorage.getItem(CONFIG.stateKey);
      if (stored) {
        var parsed = JSON.parse(stored);
        state.shape = parsed.shape || parsed.shapeId || null;
        state.shapeId = parsed.shapeId || parsed.shape || null;
        state.shapeName = parsed.shapeName || null;
        state.shapeLabel = parsed.shapeLabel || parsed.shapeName || null;
        state.size = parsed.size || null;
        state.sizeLabel = parsed.sizeLabel || null;
        state.shapeImageUrl = parsed.shapeImageUrl || parsed.shapeImage || null;
        log('Loaded from sessionStorage:', parsed);
      }

      if (window.shapeState) {
        var globalState = window.shapeState.get();
        if (globalState.shapeId) state.shapeId = globalState.shapeId;
        if (globalState.shapeName) state.shapeName = globalState.shapeName;
        if (globalState.size) state.size = globalState.size;
        if (globalState.shapeImage) state.shapeImageUrl = globalState.shapeImage;
        log('Loaded from global shapeState:', globalState);
      }
    } catch (e) {
      log('Error loading from storage:', e);
    }
  }

  /* "Choose Your Boat Mattress" -> "Choose Your King Size Boat Mattress".
     Rewrites only the words before the vehicle, so the same code is correct on
     every store (campervan / motorhome / campervan). */
  var NL_SIZE_WORDS = {
    'single': 'Single', 'double': 'Double', 'king': 'King',
    'super-king': 'Super King', 'superking': 'Super King', 'super king': 'Super King'
  };
  function applySizeToPageTitle() {
    /* Disabled 2026-09-29, Angelo's call. The heading used to be rewritten to
       "Choose Your Double Size <Vehicle> Mattress". Every mattress here is made
       to the customer's own measurements, so the size is a price band and not a
       description of their bed - someone whose bed is 133 x 186 reads a
       standard-size label in the largest type on the page and wonders whether
       they are on the right page at all. The size they picked is still shown on
       the chosen-shape bar, which is the right weight for it.
       The original code is kept below, unreached, so this can be reversed. */
    return;

    var t = document.querySelector('.nl-page-title');
    if (!t || t.getAttribute('data-sized')) return;
    var raw = state.size || state.sizeLabel || '';
    var word = NL_SIZE_WORDS[String(raw).toLowerCase().trim()];
    if (!word) return;                       /* oversized or unknown - leave it alone */
    var first = t.firstChild;
    if (!first || first.nodeType !== 3 || !/Choose Your\s/i.test(first.nodeValue)) return;
    first.nodeValue = first.nodeValue.replace(/Choose Your\s+/i, 'Choose Your ' + word + ' Size ');
    t.setAttribute('data-sized', '1');
  }

  function loadStateFromUrl() {
    var params = new URLSearchParams(window.location.search);
    
    if (params.has('shape')) {
      state.shape = params.get('shape');
      state.shapeId = params.get('shape');
    }
    if (params.has('shapeId')) {
      state.shapeId = params.get('shapeId');
      state.shape = params.get('shapeId');
    }
    if (params.has('name') || params.has('shapeName')) {
      state.shapeName = decodeURIComponent(params.get('name') || params.get('shapeName'));
      state.shapeLabel = state.shapeName;
    }
    if (params.has('shapeLabel')) {
      state.shapeLabel = decodeURIComponent(params.get('shapeLabel'));
    }
    if (params.has('size')) {
      state.size = params.get('size');
    }
    if (params.has('sizeLabel')) {
      state.sizeLabel = decodeURIComponent(params.get('sizeLabel'));
    }
    if (params.has('image') || params.has('shapeImageUrl')) {
      state.shapeImageUrl = decodeURIComponent(params.get('image') || params.get('shapeImageUrl'));
    }

    if (params.has('vmake'))   { state.vmake   = params.get('vmake');   }
    if (params.has('vmodel'))  { state.vmodel  = params.get('vmodel');  }
    if (params.has('vnumber')) { state.vnumber = params.get('vnumber'); }
    if (params.has('vyear'))   { state.vyear   = params.get('vyear');   }
    
    applySizeToPageTitle();
    log('Loaded from URL params');
  }

  function saveStateToStorage() {
    try {
      sessionStorage.setItem(CONFIG.stateKey, JSON.stringify({
        shape: state.shape,
        shapeId: state.shapeId,
        shapeName: state.shapeName,
        shapeLabel: state.shapeLabel,
        size: state.size,
        sizeLabel: state.sizeLabel,
        shapeImageUrl: state.shapeImageUrl
      }));
    } catch (e) {
      log('Error saving to sessionStorage:', e);
    }
  }

  function hasValidSelection() {
    return state.shapeId && 
           state.shapeId !== '1' && 
           state.shapeName && 
           state.shapeName !== 'Standard' &&
           state.size;
  }

  // =======================================================================
  // BENEFITS DATA
  // =======================================================================

  function loadBenefitsData() {
    var dataEl = document.getElementById('nl-benefits-data');
    if (dataEl) {
      try {
        state.benefitsData = JSON.parse(dataEl.textContent);
        log('Benefits data loaded');
      } catch (e) {
        console.error('[NL] Error parsing benefits data:', e);
      }
    }
  }

  // =======================================================================
  // PRICES
  // =======================================================================

  function loadPrices() {
    fetch(CONFIG.pricesUrl)
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to load prices');
        return response.json();
      })
      .then(function(data) {
        state.prices = data;
        log('Prices loaded');
        updateAllPricingBars();
      })
      .catch(function(e) {
        console.error('[NL] Error loading prices:', e);
      });
  }

  function getPrice(mattressId) {
    if (!state.prices || !state.size) return null;

    var pricesArray = state.prices.prices || state.prices;
    
    if (Array.isArray(pricesArray)) {
      var exactMatch = pricesArray.find(function(item) {
        return item.mattressId === mattressId && 
               item.size === state.size &&
               item.shapeId === state.shapeId;
      });
      if (exactMatch) return exactMatch.sale_price;

      var sizeMatch = pricesArray.find(function(item) {
        return item.mattressId === mattressId && item.size === state.size;
      });
      if (sizeMatch) return sizeMatch.sale_price;

      var mattressMatch = pricesArray.find(function(item) {
        return item.mattressId === mattressId;
      });
      if (mattressMatch) return mattressMatch.sale_price;
    } else {
      var mattressPrices = state.prices[mattressId];
      if (!mattressPrices) return null;

      var key = state.shapeId + '_' + state.size;
      if (mattressPrices[key]) return mattressPrices[key];
      if (mattressPrices[state.size]) return mattressPrices[state.size];
      if (mattressPrices.base) return mattressPrices.base;
    }

    return null;
  }

  // Returns the original (pre-sale) price if a sale is active, otherwise null.
  // Uses identical lookup priority to getPrice() — exact, size-only, mattressId-only.
  function getRetailPrice(mattressId) {
    if (!state.prices || !state.size) return null;

    var pricesArray = state.prices.prices || state.prices;

    if (Array.isArray(pricesArray)) {
      var exactMatch = pricesArray.find(function(item) {
        return item.mattressId === mattressId &&
               item.size === state.size &&
               item.shapeId === state.shapeId;
      });
      if (exactMatch) return exactMatch.retail_price || null;

      var sizeMatch = pricesArray.find(function(item) {
        return item.mattressId === mattressId && item.size === state.size;
      });
      if (sizeMatch) return sizeMatch.retail_price || null;

      var mattressMatch = pricesArray.find(function(item) {
        return item.mattressId === mattressId;
      });
      if (mattressMatch) return mattressMatch.retail_price || null;
    }

    return null;
  }

  function getMinPrice(mattressId) {
    if (!state.prices) return null;

    var pricesArray = state.prices.prices || state.prices;
    
    if (Array.isArray(pricesArray)) {
      var mattressPrices = pricesArray
        .filter(function(item) { return item.mattressId === mattressId; })
        .map(function(item) { return parseFloat(item.sale_price); })
        .filter(function(price) { return !isNaN(price); });
      
      if (mattressPrices.length > 0) {
        return Math.min.apply(null, mattressPrices);
      }
    } else {
      var mattressPricesObj = state.prices[mattressId];
      if (!mattressPricesObj) return null;

      var allPrices = Object.values(mattressPricesObj)
        .map(function(p) { return parseFloat(p); })
        .filter(function(p) { return !isNaN(p); });
      
      if (allPrices.length > 0) {
        return Math.min.apply(null, allPrices);
      }
    }

    return null;
  }

  // =======================================================================
  // REVIEWS
  // =======================================================================

  function loadReviewsFromGallery() {
    log('Loading reviews from Customer Gallery...');

    fetch(CONFIG.galleryUrl)
      .then(function(response) {
        if (!response.ok) throw new Error('HTTP error! Status: ' + response.status);
        return response.text();
      })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var reviewCards = doc.querySelectorAll('.review-card');
        var reviews = [];

        reviewCards.forEach(function(card, index) {
          try {
            var imageElement = card.querySelector('.review-card__image');
            var starsElement = card.querySelector('.review-card__stars');
            var textElement = card.querySelector('.review-card__text');
            var authorElement = card.querySelector('.review-card__author');
            var locationElement = card.querySelector('.review-card__location');
            var vehicleElement = card.querySelector('.review-card__vehicle');
            var mattressTypeElement = card.querySelector('.review-card__mattress-type');

            var mattressType = card.dataset.mattressType || 
                              (mattressTypeElement ? mattressTypeElement.textContent.trim() : 'essential');

            var rating = 5;
            if (starsElement) {
              var starText = starsElement.textContent;
              rating = (starText.match(/★/g) || []).length;
            }

            reviews.push({
              id: 'gallery-' + index,
              mattressId: mattressType,
              reviewer_name: authorElement ? authorElement.textContent.trim() : 'Anonymous',
              review_text: textElement ? textElement.textContent.trim() : '',
              location: locationElement ? locationElement.textContent.trim() : '',
              vehicle_type: vehicleElement ? vehicleElement.textContent.trim() : '',
              star_rating: rating,
              product_image: imageElement ? imageElement.src : ''
            });
          } catch (e) {
            console.warn('[NL] Error parsing review card:', e);
          }
        });

        state.reviewsData = reviews;
        log('Loaded ' + reviews.length + ' reviews from gallery');
      })
      .catch(function(error) {
        console.error('[NL] Error loading reviews from gallery:', error);
        if (window.mattressReviews) {
          state.reviewsData = window.mattressReviews;
          log('Using fallback local reviews');
        }
      });
  }

  // =======================================================================
  // UI UPDATES
  // =======================================================================

  function updateUI() {
    updateAllPricingBars();
  }

  function getShapeSelectionUrl() {
    var baseUrl = '/';
    if (state.step1Url && state.step1Url !== '/') {
      baseUrl = state.step1Url;
    } else if (CONFIG.shapeUrl) {
      baseUrl = CONFIG.shapeUrl;
    }
    if (baseUrl.indexOf('#size-selector') !== -1) return baseUrl;
    return baseUrl + (baseUrl.indexOf('#') === -1 ? '#size-selector' : '');
  }

  function updateAllPricingBars() {
    var cards = document.querySelectorAll('.nl-card');
    var selectShapeLink = document.getElementById('nl-select-shape-link');
    
    if (selectShapeLink) {
      selectShapeLink.href = getShapeSelectionUrl();
    }

    var step1Link = document.getElementById('nl-step1-link');
    if (step1Link) {
      step1Link.href = getShapeSelectionUrl();
    }

    var hasSelection = hasValidSelection();

    cards.forEach(function(card) {
      updatePricingBar(card, hasSelection);
    });
  }

  function updatePricingBar(card, hasSelection) {
    var mattressId = card.dataset.mattressId;
    var pricingBar = card.querySelector('.nl-pricing-bar');
    if (!pricingBar) return;

    pricingBar.classList.add('nl-visible');
    pricingBar.classList.toggle('nl-no-selection', !hasSelection);
    // the shape bar now lives on the card, not in the pricing column
    card.classList.toggle('nl-no-selection', !hasSelection);

    var shapeThumb = card.querySelector('.nl-shape-thumb');
    var shapeName = card.querySelector('.nl-shape-name');
    var changeShapeBtn = card.querySelector('.nl-change-shape');
    var priceEl = card.querySelector('.nl-price');

    if (hasSelection) {
      if (shapeThumb) {
        shapeThumb.src = state.shapeImageUrl || '';
      }

      if (shapeName) {
        // every shape here is a boat mattress - repeating it on all 8 cards
        // just pushed the name past the width it has to live in
        var _raw = state.shapeName || state.shapeLabel || '';
        var _short = _raw.replace(/\s*boat\s+mattress\s*$/i, '').trim() || _raw;
        var label = [_short, state.sizeLabel || state.size]
          .filter(Boolean)
          .join(' · ');
        shapeName.textContent = label || 'Selected Shape';
      }

      if (changeShapeBtn) {
        changeShapeBtn.textContent = 'Change Shape and Size';
      }

      if (priceEl) {
        var price = getPrice(mattressId);
        var retailPrice = getRetailPrice(mattressId);

        if (price && retailPrice) {
          // Sale is active — exact price for the chosen shape+size
          // Step-1 parity: "% OFF" badge sits inline beside the struck "Was" price.
          var pct = Math.round((1 - (parseFloat(price) / parseFloat(retailPrice))) * 100);
          var offBadge = pct > 0 ? '<span class="nl-sale-card-badge">' + pct + '% OFF</span>' : '';
          priceEl.innerHTML =
            '<span class="nl-price-wasline"><s class="nl-price-was">Was \u00a3' + retailPrice + '</s>' + offBadge + '</span>' +
            '<span class="nl-price-now">Now \u00a3' + price + '</span>';
        } else if (price) {
          /* 2026-10-25: split like Step 1's price block */
          priceEl.innerHTML = '<span class="nl-price-amount">\u00a3' + price + '</span>';
          var badgeElOff = card.querySelector('.nl-sale-card-badge');
          if (badgeElOff) { badgeElOff.style.display = 'none'; }
        } else {
          priceEl.textContent = 'Price on request';
        }
      }
    } else {
      if (shapeName) {
        shapeName.textContent = 'No shape selected';
      }

      if (changeShapeBtn) {
        changeShapeBtn.textContent = 'Select Shape and Size';
      }

      if (priceEl) {
        var minPrice = getMinPrice(mattressId);
        if (minPrice) {
          /* 2026-10-25: small "From" + big amount, as on Step 1 */
          priceEl.innerHTML = '<span class="nl-price-label">From</span><span class="nl-price-amount">\u00a3' + minPrice + '</span>';
        } else {
          priceEl.textContent = 'From \u00a3---';
        }
      }
      // Hide any sale badge while no shape/size is selected
      var badgeNoSel = card.querySelector('.nl-sale-card-badge');
      if (badgeNoSel) { badgeNoSel.style.display = 'none'; }
    }
  }

  // =======================================================================
  // IMAGE GALLERY (Legacy - kept for compatibility)
  // =======================================================================

  NL.swapImage = function(mattressId, imageType) {
    var mainImg = document.getElementById(mattressId + '-main-img');
    var card = document.querySelector('[data-mattress-id="' + mattressId + '"]');
    
    if (!mainImg || !card) return;

    var thumbIndex = imageType === 'thumb1' ? 0 : 1;
    var thumbnails = card.querySelectorAll('.nl-thumbnail img');
    var clickedThumb = thumbnails[thumbIndex];
    
    if (!clickedThumb) return;

    var mainSrc = mainImg.src;
    var thumbSrc = clickedThumb.src;
    
    mainImg.src = thumbSrc;
    clickedThumb.src = mainSrc;
    
    var thumbContainers = card.querySelectorAll('.nl-thumbnail');
    thumbContainers.forEach(function(thumb, index) {
      thumb.classList.toggle('active', index === thumbIndex);
    });
    
    log('Swapped images:', mattressId, 'main ↔', imageType);
  };

  NL.resetMainImage = function(mattressId) {
    var mainImg = document.getElementById(mattressId + '-main-img');
    var card = document.querySelector('[data-mattress-id="' + mattressId + '"]');
    
    if (!mainImg || !card) return;

    var currentSrc = mainImg.src;
    var baseUrl = currentSrc.substring(0, currentSrc.lastIndexOf('/') + 1);
    
    mainImg.src = baseUrl + mattressId + '-main.jpg';
    
    var thumbnails = card.querySelectorAll('.nl-thumbnail img');
    if (thumbnails[0]) thumbnails[0].src = baseUrl + mattressId + '-thumb1.jpg';
    if (thumbnails[1]) thumbnails[1].src = baseUrl + mattressId + '-thumb2.jpg';
    
    card.querySelectorAll('.nl-thumbnail').forEach(function(thumb) {
      thumb.classList.remove('active');
    });
    
    log('Reset all images:', mattressId);
  };

  // =======================================================================
  // IMAGE CAROUSEL
  // =======================================================================

  NL.carouselNext = function(mattressId) {
    var img = document.getElementById(mattressId + '-main-img');
    if (!img) return;
    
    var images = img.dataset.images.split('|');
    var current = parseInt(img.dataset.current) || 0;
    current = (current + 1) % images.length;
    
    NL.carouselGoTo(mattressId, current);
  };

  NL.carouselPrev = function(mattressId) {
    var img = document.getElementById(mattressId + '-main-img');
    if (!img) return;
    
    var images = img.dataset.images.split('|');
    var current = parseInt(img.dataset.current) || 0;
    current = (current - 1 + images.length) % images.length;
    
    NL.carouselGoTo(mattressId, current);
  };

  NL.carouselGoTo = function(mattressId, index) {
    var img = document.getElementById(mattressId + '-main-img');
    var dotsContainer = document.getElementById(mattressId + '-dots');
    
    if (!img) return;
    
    var images = img.dataset.images.split('|');
    
    img.src = images[index];
    img.dataset.current = index;
    
    if (dotsContainer) {
      var dots = dotsContainer.querySelectorAll('.nl-dot');
      dots.forEach(function(dot, i) {
        dot.classList.toggle('active', i === index);
      });
    }
    
    log('Carousel:', mattressId, 'showing image', index + 1, 'of', images.length);
  };

  NL.initCarouselSwipe = function() {
    var carousels = document.querySelectorAll('.nl-carousel');
    
    carousels.forEach(function(carousel) {
      var startX = 0;
      var startY = 0;
      
      carousel.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });
      
      carousel.addEventListener('touchend', function(e) {
        var endX = e.changedTouches[0].clientX;
        var endY = e.changedTouches[0].clientY;
        var diffX = startX - endX;
        var diffY = startY - endY;
        
        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
          var card = carousel.closest('[data-mattress-id]');
          if (!card) return;
          
          var mattressId = card.dataset.mattressId;
          
          if (diffX > 0) {
            NL.carouselNext(mattressId);
          } else {
            NL.carouselPrev(mattressId);
          }
        }
      }, { passive: true });
    });
    
    log('Carousel swipe initialised');
  };

  // =======================================================================
  // IMAGE LIGHTBOX
  // =======================================================================

  NL.openLightbox = function(imageSrc, altText) {
    if (!imageSrc) return;
    
    log('Opening lightbox:', altText);

    NL.closeLightbox();

    var lightbox = document.createElement('div');
    lightbox.className = 'nl-lightbox';
    lightbox.id = 'nl-lightbox';
    
    lightbox.innerHTML = 
      '<div class="nl-lightbox-overlay"></div>' +
      '<div class="nl-lightbox-content">' +
        '<div class="nl-lightbox-image-wrapper">' +
          '<img src="' + imageSrc + '" alt="' + (altText || 'Mattress image') + '">' +
          '<button class="nl-lightbox-close" aria-label="Close lightbox">&times;</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(lightbox);
    document.body.classList.add('nl-modal-open');

    lightbox.querySelector('.nl-lightbox-overlay').addEventListener('click', function() {
      NL.closeLightbox();
    });

    lightbox.querySelector('.nl-lightbox-close').addEventListener('click', function() {
      NL.closeLightbox();
    });
    
    log('Lightbox opened');
  };

  NL.closeLightbox = function() {
    var lightbox = document.getElementById('nl-lightbox');
    if (lightbox) {
      lightbox.remove();
      document.body.classList.remove('nl-modal-open');
      log('Lightbox closed');
    }
  };

  // =======================================================================
  // CATEGORY FILTER
  // =======================================================================

  function hideFilterOnlySections() {
    var filterOnlySections = document.querySelectorAll('[data-filter-only="true"]');
    filterOnlySections.forEach(function(section) {
      section.style.display = 'none';
    });
    
    var secondaryCards = document.querySelectorAll('.nl-card[data-appearance="secondary"]');
    secondaryCards.forEach(function(card) {
      card.style.display = 'none';
    });
    
    log('Filter-only sections and secondary cards hidden');
  }

  NL.filterCategory = function(category) {
    var buttons = document.querySelectorAll('.nl-filter-btn');
    var sections = document.querySelectorAll('.nl-category-section');
    
    buttons.forEach(function(btn) {
      if (btn.dataset.filter === category) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
    
    if (category === 'all') {
      sections.forEach(function(section) {
        if (section.dataset.filterOnly === 'true') {
          section.style.display = 'none';
        } else {
          section.style.display = 'block';
        }
      });
      
      var secondaryCards = document.querySelectorAll('.nl-card[data-appearance="secondary"]');
      secondaryCards.forEach(function(card) {
        card.style.display = 'none';
      });
      
      var firstSection = document.querySelector('.nl-category-section:not([data-filter-only="true"])');
      if (firstSection) {
        setTimeout(function() {
          firstSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    } else {
      var sectionMap = {
        'value': ['nl-section-value'],
        'back': ['nl-section-back'],
        'cooling': ['nl-section-cooling'],
        'luxury': ['nl-section-luxury'],
        'toppers': ['nl-section-toppers'],
        'popular': ['nl-section-popular']
      };
      
      var targetSections = sectionMap[category] || [];
      
      sections.forEach(function(section) {
        if (targetSections.indexOf(section.id) !== -1) {
          section.style.display = 'block';
          
          var cards = section.querySelectorAll('.nl-card');
          cards.forEach(function(card) {
            card.style.display = '';
          });
        } else {
          section.style.display = 'none';
        }
      });
      
      if (targetSections.length > 0) {
        var targetEl = document.getElementById(targetSections[0]);
        if (targetEl) {
          setTimeout(function() {
            var headerOffset = 80;
            var elementPosition = targetEl.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
            
            targetEl.classList.add('nl-section-highlight');
            setTimeout(function() {
              targetEl.classList.remove('nl-section-highlight');
            }, 1500);
          }, 100);
        }
      }
    }
    
    log('Filtered to category:', category);
  };

  NL.showAllCategories = function() {
    NL.filterCategory('all');
  };

  // =======================================================================
  // SALE COUNTDOWN TIMER
  // =======================================================================

  NL.initCountdown = function() {
    var countdownEl = document.getElementById('nl-sale-countdown');
    if (!countdownEl) return;
    
    var endDateStr = countdownEl.dataset.endDate;
    if (!endDateStr) return;
    
    var endDate = new Date(endDateStr + 'T23:59:59');
    
    if (isNaN(endDate.getTime())) {
      log('Invalid sale end date:', endDateStr);
      return;
    }
    
    function updateCountdown() {
      var now = new Date();
      var diff = endDate - now;
      
      if (diff <= 0) {
        var banner = document.getElementById('nl-sale-banner');
        if (banner) {
          countdownEl.textContent = 'Offer has ended';
          banner.style.opacity = '0.6';
        }
        return;
      }
      
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      
      var text = '';
      if (days > 1) {
        text = 'Ends in ' + days + ' days';
      } else if (days === 1) {
        text = 'Ends tomorrow';
      } else if (hours > 0) {
        text = 'Ends today — ' + hours + 'h ' + minutes + 'm remaining';
      } else {
        text = 'Ending very soon — ' + minutes + ' minutes left';
      }
      
      countdownEl.textContent = text;
    }
    
    updateCountdown();
    setInterval(updateCountdown, 60000);
    
    log('Sale countdown initialised, ends:', endDateStr);
  };

  // =======================================================================
  // SCROLL TO MATTRESS
  // =======================================================================

  NL.scrollToMattress = function(mattressId) {
    log('Scrolling to mattress:', mattressId);
    
    var card = document.querySelector('.nl-card[data-mattress-id="' + mattressId + '"][data-appearance="primary"]');
    
    if (!card) {
      card = document.querySelector('.nl-card[data-mattress-id="' + mattressId + '"]');
    }
    
    if (!card) {
      log('Card not found for:', mattressId);
      return;
    }
    
    var activeFilter = document.querySelector('.nl-filter-btn.active');
    if (activeFilter && activeFilter.dataset.filter !== 'all') {
      NL.filterCategory('all');
    }
    
    var section = card.closest('.nl-category-section');
    if (section && section.style.display === 'none') {
      section.style.display = 'block';
    }
    
    setTimeout(function() {
      var headerOffset = 80;
      var elementPosition = card.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      
      card.classList.add('nl-card-highlight');
      setTimeout(function() {
        card.classList.remove('nl-card-highlight');
      }, 2000);
    }, 150);
  };

  // =======================================================================
  // BENEFITS MODAL
  // =======================================================================

  NL.openBenefitsModal = function(blockId) {
    if (!state.benefitsData) loadBenefitsData();
    
    var data = state.benefitsData ? state.benefitsData[blockId] : null;
    if (!data) {
      console.error('[NL] No benefits data for block:', blockId);
      return;
    }

    var modal = document.getElementById('nl-benefits-modal');
    var overlay = document.getElementById('nl-modal-overlay');
    var title = document.getElementById('nl-modal-title');
    var list = document.getElementById('nl-modal-benefits-list');

    if (!modal || !overlay || !title || !list) return;

    title.textContent = data.title + ' Benefits';

    list.innerHTML = data.benefits
      .filter(function(b) { return b && b.text; })
      .map(function(benefit) {
        return '<li class="' + (benefit.included ? 'nl-benefit-included' : 'nl-benefit-excluded') + '">' +
          '<span class="' + (benefit.included ? 'nl-modal-check' : 'nl-modal-cross') + '">' +
            (benefit.included ? '✓' : '✗') +
          '</span>' +
          benefit.text +
        '</li>';
      }).join('');

    overlay.classList.add('nl-visible');
    modal.classList.add('nl-visible');
    document.body.classList.add('nl-modal-open');
    
    log('Opened benefits modal:', blockId);
  };

  NL.closeBenefitsModal = function() {
    var modal = document.getElementById('nl-benefits-modal');
    var overlay = document.getElementById('nl-modal-overlay');

    if (modal) modal.classList.remove('nl-visible');
    if (overlay) overlay.classList.remove('nl-visible');
    document.body.classList.remove('nl-modal-open');
    
    log('Closed benefits modal');
  };

  // =======================================================================
  // REVIEWS MODAL
  // =======================================================================

  NL.openReviewsModal = function(mattressId) {
    log('Opening reviews modal for:', mattressId);

    var modal = document.getElementById('nl-reviews-modal');
    var overlay = document.getElementById('nl-reviews-overlay');
    var title = document.getElementById('nl-reviews-title');
    var container = document.getElementById('nl-reviews-container');
    var emptyMessage = document.getElementById('nl-reviews-empty');

    if (!modal || !container) {
      console.warn('[NL] Reviews modal elements not found');
      return;
    }

    if (title) {
      var mattressName = MATTRESS_NAMES[mattressId] || 'Mattress';
      title.textContent = mattressName + ' - Customer Reviews';
    }

    container.innerHTML = '<div class="nl-reviews-loading"><div class="nl-spinner"></div><p>Loading reviews...</p></div>';

    if (overlay) overlay.classList.add('nl-visible');
    modal.classList.add('nl-visible');
    document.body.classList.add('nl-modal-open');

    var baseMattressType = mattressId.replace(/^swift-/, '');
    var mattressReviews = state.reviewsData.filter(function(review) {
      return review.mattressId === mattressId || review.mattressId === baseMattressType;
    });

    log('Found ' + mattressReviews.length + ' reviews for ' + mattressId);

    container.innerHTML = '';

    if (mattressReviews.length === 0) {
      if (emptyMessage) {
        emptyMessage.style.display = 'flex';
      } else {
        container.innerHTML = '<div class="nl-reviews-empty"><p>No reviews yet for this mattress.</p><p>Be the first to leave a review!</p></div>';
      }
    } else {
      if (emptyMessage) emptyMessage.style.display = 'none';

      mattressReviews.forEach(function(review) {
        var stars = '';
        for (var i = 0; i < review.star_rating; i++) stars += '★';
        for (var j = review.star_rating; j < 5; j++) stars += '☆';
        
        var reviewEl = document.createElement('div');
        reviewEl.className = 'nl-review-item';
        reviewEl.innerHTML = '<div class="nl-review-main">' +
          '<div class="nl-review-image">' +
            '<img src="' + (review.product_image || FALLBACK_IMAGE) + '" alt="' + review.reviewer_name + '\'s Review" onerror="this.src=\'' + FALLBACK_IMAGE + '\'">' +
          '</div>' +
          '<div class="nl-review-content">' +
            '<div class="nl-review-header">' +
              '<span class="nl-review-name">' + review.reviewer_name + '</span>' +
              '<span class="nl-review-stars">' + stars + '</span>' +
            '</div>' +
            '<p class="nl-review-text">' + review.review_text + '</p>' +
            '<div class="nl-review-meta">' +
              (review.vehicle_type ? '<span><strong>Vehicle:</strong> ' + review.vehicle_type + '</span>' : '') +
              (review.location ? '<span><strong>Location:</strong> ' + review.location + '</span>' : '') +
            '</div>' +
          '</div>' +
        '</div>';
        container.appendChild(reviewEl);
      });
    }

    log('Reviews modal opened');
  };

  NL.closeReviewsModal = function() {
    var modal = document.getElementById('nl-reviews-modal');
    var overlay = document.getElementById('nl-reviews-overlay');

    if (modal) modal.classList.remove('nl-visible');
    if (overlay) overlay.classList.remove('nl-visible');
    document.body.classList.remove('nl-modal-open');
    
    log('Closed reviews modal');
  };

  // =======================================================================
  // DESCRIPTION MODAL
  // =======================================================================

  NL.openDescriptionModal = function(mattressId, descriptionUrl) {
    log('Opening description modal for:', mattressId);

    var modal = document.getElementById('nl-description-modal');
    var overlay = document.getElementById('nl-description-overlay');
    var title = document.getElementById('nl-description-title');
    var container = document.getElementById('nl-description-container');

    if (!modal || !container) {
      console.warn('[NL] Description modal elements not found');
      return;
    }

    if (title) {
      var mattressName = MATTRESS_NAMES[mattressId] || 'Mattress';
      title.textContent = mattressName;
    }

    container.innerHTML = '<div class="nl-description-loading"><div class="nl-spinner"></div><p>Loading description...</p></div>';

    if (overlay) overlay.classList.add('nl-visible');
    modal.classList.add('nl-visible');
    document.body.classList.add('nl-modal-open');

    loadDescriptionFromPage(descriptionUrl || '/pages/' + mattressId + '-description', container);

    log('Description modal opened');
  };

  function loadDescriptionFromPage(url, container) {
    log('Fetching description from:', url);

    fetch(url)
      .then(function(response) {
        if (!response.ok) throw new Error('HTTP error! Status: ' + response.status);
        return response.text();
      })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var content = doc.querySelector('main') || 
                      doc.querySelector('.page-content') || 
                      doc.querySelector('.rte') || 
                      doc.querySelector('.content') || 
                      doc.querySelector('body');

        if (content) {
          var unwanted = content.querySelectorAll('nav, header, footer, .navigation, .breadcrumb, script, style');
          unwanted.forEach(function(el) { el.remove(); });

          container.innerHTML = content.innerHTML;
          log('Description loaded successfully');
        } else {
          throw new Error('Could not find content');
        }
      })
      .catch(function(error) {
        console.error('[NL] Error loading description:', error);
        
        container.innerHTML = '<div class="nl-description-error">' +
          '<h2>Description Temporarily Unavailable</h2>' +
          '<p>We\'re having trouble loading the full description.</p>' +
          '<p><a href="' + url + '" target="_blank" class="nl-link">View full description in new tab \u2192</a></p>' +
        '</div>';
      });
  }

  NL.closeDescriptionModal = function() {
    var modal = document.getElementById('nl-description-modal');
    var overlay = document.getElementById('nl-description-overlay');

    if (modal) modal.classList.remove('nl-visible');
    if (overlay) overlay.classList.remove('nl-visible');
    document.body.classList.remove('nl-modal-open');
    
    log('Closed description modal');
  };

  // =======================================================================
  // VIDEO MODAL
  // =======================================================================

  NL.openVideoModal = function(videoUrl, mattressName) {
    log('Opening video modal for:', mattressName, 'URL:', videoUrl);

    var modal = document.getElementById('nl-video-modal');
    var overlay = document.getElementById('nl-video-overlay');
    var title = document.getElementById('nl-video-title');
    var videoContainer = document.getElementById('nl-video-container');
    var placeholder = document.getElementById('nl-video-placeholder');
    var videoPlayer = document.getElementById('nl-video-player');
    var videoSource = document.getElementById('nl-video-source');

    if (!modal) {
      console.warn('[NL] Video modal not found');
      if (videoUrl && videoUrl.trim() !== '') {
        window.open(videoUrl, '_blank');
      }
      return;
    }

    if (title) {
      title.textContent = (mattressName || 'Product') + ' Video';
    }

    var hasVideo = videoUrl && videoUrl.trim() !== '';

    if (hasVideo) {
      if (videoContainer) videoContainer.style.display = 'block';
      if (placeholder) placeholder.style.display = 'none';
      
      if (videoSource && videoPlayer) {
        videoSource.src = videoUrl;
        videoPlayer.load();
      }
    } else {
      if (videoContainer) videoContainer.style.display = 'none';
      if (placeholder) placeholder.style.display = 'block';
    }

    if (overlay) overlay.classList.add('nl-visible');
    modal.classList.add('nl-visible');
    document.body.classList.add('nl-modal-open');

    log('Video modal opened, hasVideo:', hasVideo);
  };

  NL.closeVideoModal = function() {
    var modal = document.getElementById('nl-video-modal');
    var overlay = document.getElementById('nl-video-overlay');
    var videoPlayer = document.getElementById('nl-video-player');

    if (videoPlayer) {
      videoPlayer.pause();
      videoPlayer.currentTime = 0;
    }

    if (modal) modal.classList.remove('nl-visible');
    if (overlay) overlay.classList.remove('nl-visible');
    document.body.classList.remove('nl-modal-open');
    
    log('Closed video modal');
  };

  // =======================================================================
  // NAVIGATION
  // =======================================================================

  NL.selectMattress = function(mattressId) {
    if (!hasValidSelection()) {
      NL.goBackToShapeSelection();
      return;
    }

    saveStateToStorage();

    var typeId = mattressId;
    
    if (state.isSwift && typeId.indexOf('swift-') !== 0) {
      typeId = 'swift-' + typeId;
    }

    var mattressType = String(typeId).toLowerCase().replace(/[^a-z0-9-]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
    var sizeSlug = normaliseSizeSlug(state.size);
    var shapeSlug = getSafeShapeSlug(state.shapeId, state.size);

    var productUrl = '/products/' + mattressType + '-' + sizeSlug + '-' + shapeSlug;
    var vParams = [];
    if (state.vmake)   vParams.push('vmake='   + encodeURIComponent(state.vmake));
    if (state.vmodel)  vParams.push('vmodel='  + encodeURIComponent(state.vmodel));
    if (state.vnumber) vParams.push('vnumber=' + encodeURIComponent(state.vnumber));
    if (state.vyear)   vParams.push('vyear='   + encodeURIComponent(state.vyear));
    if (vParams.length) productUrl += '?' + vParams.join('&');

    log('Navigating to mattress:', productUrl);
    window.location.href = productUrl;
  };

  NL.selectTopper = function(topperId) {
    if (!hasValidSelection()) {
      NL.goBackToShapeSelection();
      return;
    }

    saveStateToStorage();

    var typeId = topperId;
    
    if (state.isSwift && typeId.indexOf('swift-') !== 0) {
      typeId = 'swift-' + typeId;
    }

    var topperType = String(typeId).toLowerCase().replace(/[^a-z0-9-]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
    var sizeSlug = normaliseSizeSlug(state.size);
    var shapeSlug = getSafeShapeSlug(state.shapeId, state.size);

    var productUrl = '/products/' + topperType + '-' + sizeSlug + '-' + shapeSlug;
    var vParams = [];
    if (state.vmake)   vParams.push('vmake='   + encodeURIComponent(state.vmake));
    if (state.vmodel)  vParams.push('vmodel='  + encodeURIComponent(state.vmodel));
    if (state.vnumber) vParams.push('vnumber=' + encodeURIComponent(state.vnumber));
    if (state.vyear)   vParams.push('vyear='   + encodeURIComponent(state.vyear));
    if (vParams.length) productUrl += '?' + vParams.join('&');

    log('Navigating to topper:', productUrl);
    window.location.href = productUrl;
  };

  NL.goBackToShapeSelection = function() {
    var shapeUrl = getShapeSelectionUrl();
    
    if (hasValidSelection()) {
      log('Has selection - navigating to shape selection page');
      window.location.href = shapeUrl;
      return;
    }
    
    log('No selection - showing popup');
    
    var noSelectionMsg = document.getElementById('nl-no-selection');
    var selectShapeLink = document.getElementById('nl-select-shape-link');
    
    if (selectShapeLink) {
      selectShapeLink.href = shapeUrl;
    }
    
    if (noSelectionMsg) {
      noSelectionMsg.style.display = 'flex';
      
      noSelectionMsg.onclick = function(e) {
        if (e.target === noSelectionMsg) {
          noSelectionMsg.style.display = 'none';
        }
      };
      
      var escHandler = function(e) {
        if (e.key === 'Escape') {
          noSelectionMsg.style.display = 'none';
          document.removeEventListener('keydown', escHandler);
        }
      };
      document.addEventListener('keydown', escHandler);
    } else {
      window.location.href = shapeUrl;
    }
  };

  function getSafeShapeSlug(shapeId, size) {
    if (!shapeId) return 'standard';
    
    var shapeSlug = String(shapeId).toLowerCase();
    
    if (size) {
      var sizePrefix = size.toLowerCase() + '-';
      if (shapeSlug.indexOf(sizePrefix) === 0) {
        shapeSlug = shapeSlug.substring(sizePrefix.length);
      }
      var normalisedPrefix = normaliseSizeSlug(size) + '-';
      if (shapeSlug.indexOf(normalisedPrefix) === 0) {
        shapeSlug = shapeSlug.substring(normalisedPrefix.length);
      }
    }
    
    shapeSlug = shapeSlug.replace(/[^a-z0-9-]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
    
    return shapeSlug || 'standard';
  }

  function normaliseSizeSlug(size) {
    if (!size) return '';
    var slug = String(size).toLowerCase().replace(/[^a-z0-9-]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
    slug = slug.replace('superking', 'super-king');
    return slug;
  }

  // =======================================================================
  // EVENT LISTENERS
  // =======================================================================

  function setupEventListeners() {
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        NL.closeBenefitsModal();
        NL.closeReviewsModal();
        NL.closeDescriptionModal();
        NL.closeVideoModal();
        NL.closeLightbox();
      }
    });

    document.addEventListener('click', function(e) {
      var reviewsLink = e.target.closest('[data-action="open-reviews"]');
      if (reviewsLink) {
        e.preventDefault();
        var mattressId = reviewsLink.dataset.mattressId;
        if (mattressId) {
          NL.openReviewsModal(mattressId);
        }
      }

      var descriptionLink = e.target.closest('[data-action="open-description"]');
      if (descriptionLink) {
        e.preventDefault();
        var mattressId = descriptionLink.dataset.mattressId;
        var descriptionUrl = descriptionLink.getAttribute('href');
        if (mattressId) {
          NL.openDescriptionModal(mattressId, descriptionUrl);
        }
      }

      var videoLink = e.target.closest('[data-action="open-video"]');
      if (videoLink) {
        e.preventDefault();
        var mattressId = videoLink.dataset.mattressId;
        var videoUrl = videoLink.dataset.videoUrl || '';
        var mattressName = MATTRESS_NAMES[mattressId] || 'Product';
        NL.openVideoModal(videoUrl, mattressName);
      }
    });

    document.addEventListener('mattressShapeSelected', function(e) {
      if (e.detail) {
        log('Shape selection event received:', e.detail);
        
        if (e.detail.size) {
          state.size = e.detail.size.replace(/^superking$/i, 'super-king');
        }
        if (e.detail.shapeId) {
          state.shapeId = e.detail.shapeId;
          state.shape = e.detail.shapeId;
        }
        if (e.detail.shapeName) {
          state.shapeName = e.detail.shapeName;
          state.shapeLabel = e.detail.shapeName;
        }
        if (e.detail.shapeImage) {
          state.shapeImageUrl = e.detail.shapeImage;
        }

        updateUI();
      }
    });

    log('Event listeners set up');
  }

  // =======================================================================
  // INIT
  // =======================================================================

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  log('newlayout.js v3.5 loaded');

})();